// extracted by mini-css-extract-plugin
export default {"container":"AnimatedStar_container__5DjH0","rotate":"AnimatedStar_rotate__SvCiD"};